import { useEffect, useRef } from 'react';

export const GradientCanvas = () => {
    const canvasRef = useRef(null);
    const gradientRef = useRef(null);

    useEffect(() => {
        const init = () => {
            const Gradient = window.Gradient;
            if (Gradient && canvasRef.current && !gradientRef.current) {
                gradientRef.current = new Gradient();
                gradientRef.current.initGradient(canvasRef.current);
            }
        };

        if (!document.querySelector('script[src="/gradient.js"]')) {
            const script = document.createElement('script');
            script.src = '/gradient.js';
            script.async = true;

            script.onload = () => {
                const Gradient = window.Gradient;
                if (Gradient && canvasRef.current) {
                    const gradient = new Gradient();
                    gradient.initGradient('#gradient-canvas');
                }
            };
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
                gradientRef.current?.disconnect?.();
            };
        } else {
            init(); // when already loaded
            return () => {
                gradientRef.current?.disconnect?.();
            };
        }
    }, []);

    return (
        <canvas
            id="gradient-canvas"
            ref={canvasRef}
            style={{
                width: '100vw',
                height: 'calc(var(--vh, 1vh) * 100)',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: -1,
            }}
        />
    );
};
